// angular
import {
    Component,
    AfterViewInit,
    OnInit,
    OnChanges,
    ViewChild,
    Input,
    EventEmitter,
    Output,
    SimpleChanges,
    OnDestroy, ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
// services
import { AuthService } from '../../core/auth.service';
import { ProposalDiagnosisService } from './proposal-diagnosis.service';
import { BaseService } from '../../shared/base.service';
// others
import { BaseComponent } from '../../shared/base.component';
import { AppService } from '../../app.service';
import { PatientService } from '../patient.service';
import {PerfectScrollbarComponent} from 'ngx-perfect-scrollbar';
import { AccordionComponent } from 'ngx-bootstrap/accordion';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ProposalInterface } from '../../models/proposal.interface';
import * as _ from 'lodash';
import { DialogComponent } from '../../dialog/dialog.component';
import { ManualDiagnosisComponent } from './manual-diagnosis/manual-diagnosis.component';

@Component({
    selector: 'proposal-diagnosis-component',
    templateUrl: 'proposal-diagnosis.component.html',
    styleUrls: ['proposal-diagnosis.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        ProposalDiagnosisService,
        BaseService
    ]
})

export class ProposalDiagnogisComponent extends BaseComponent implements OnInit {
    @Input() isCollapsed: boolean;
    @Input() diagnosesProposal: ProposalInterface[] = [];
    @Input() patientId: number;
    @Input() nodeClassList: any;
    @Input() symptomMapId: number;
    @Input() isFullScreen: boolean;
    @Input() mapData : any;
    @Input() isDisabled : boolean;
    @Input() overviewDiagnosis : boolean = false;
    @Input() selectedCurrentQuestionnaire : any;

    @Output() closeProposalDiagnosis = new EventEmitter();
    @Output() highlight = new EventEmitter();
    @Output() updateMap = new EventEmitter();
    @Output() highlightDomain = new EventEmitter();
    @Output() highlightSymptom = new EventEmitter();
    @Output() closeInteractive = new EventEmitter();
    @Output() setMapDisable = new EventEmitter();
    @Output() showErrorModal = new EventEmitter();

    interactiveMapSub: Subscription;

    ld = _;
    // used to mark the subcategory as selected when selecting its diagnosis
    selectedSubCatId: number;

    // used to show the selected diagnosis
    openedCategoryId: number;
    openedSubcategoryId: number;
    openedDiagnosisId: number;

    noneSelectedItem : number;

    @ViewChild('ps', { static: false }) perfectScrollbarComp: PerfectScrollbarComponent;
    @ViewChild('tabs', {static: false}) tabs: TabsetComponent;
    @ViewChild('accordion', { static: false }) accordionComp: AccordionComponent;
    @ViewChild('dialog', { static: false }) dialog: DialogComponent;
    @ViewChild('manualDiagnosis', { static: false }) manualDiagnosis: ManualDiagnosisComponent;

    disabledNoneDiagnosis: boolean = false;
    waitingAPI: boolean = false;
    tabSelected = 0;
    lang: string = this.translate.currentLang;
    selectedSymptom: any;
    selectedFeelings: any;
    selectedFeeling: any;
    primaryOnMapItem: any;
    acceptedDiagnosis = [];
    dismissedDiagnosis = [];
    toReviewDiagnosis = [];
    proposal: ProposalInterface;
    stickyWidth = '494px';
    stickyHeight = '110px';
    activeCriteria: any;
    activeProposalDiagnosis: ProposalInterface;
    lastAccessedProposalDiagnosis: ProposalInterface;
    filteredProposals: ProposalInterface[] = [];
    firstInit = true;
    selectionList = {
        mild: {
            name: 'mild',
            rating: 16.66,
            class: 'rating-low'
        },
        moderate: {
            name: 'moderate',
            rating: 50,
            class: 'rating-middle'
        },
        severe: {
            name: 'severe',
            rating: 83.33,
            class: 'rating-high'
        },
        none: {
            name: 'none',
            rating: 1,
            class: 'rating-none'
        },
        anamnestic: {
            name: 'anamnestic',
            rating: 1,
            class: 'anamnestic'
        }
    };
    hoverOnSymptom = false;
    targetSymptom: any;
    timer: any;
    isCriteriaCollapsed = true;
    GROUPTYPES = {
        SYMPTOM: 1,
        TEXT: 2,
        CONDITIONS: 3,
        EXCLUDE_SYMPTOM: 4
    };
    statusTemp = 2;
    CRITERIA_STATUSES = {
      review_assauge : 2,
      partially_fullfilled : 3,
      not_fullfilled : 1,
      fullfilled : 4
    };
    extendFiltered = {
        domain: null,
        icdChapter: null,
        probability: <number> null
    };
    defaultFilters = {
        domain: [],
        icdChapter: [],
        probability: [
            {
                id: 1,
                name: '>80%',
                value: 80
            },
            {
                id: 2,
                name: '>60%',
                value: 60,
            },
            {
                id: 3,
                name: '>40%',
                value: 40,
            },
            {
                id: 4,
                name: '>20%',
                value: 20,
            }]
    };
    extendFilters: {
        domain: any,
        icdChapter: any,
        probability: any
    };
    LEVEL = {
        criteria: 1,
        group: 2,
    };
    PROPOSAL_ACTION = {
        accept: 1,
        dismiss: 2,
        review: 0,
        manual: 3,
    };
    recentUpdatedTab = 0;
    showInList = {
        accept: 5,
        dismiss: 5,
        review: 5,
    };
    countingDiagnosis = {
        accept: 0,
        dismiss: 0,
        review: 0
    };

    updateDiagnosisSub: Subscription;
    diagnosesSub: Subscription;
    oldActiveCriteria = null;
    currentHighlightDiagnosis = null;
    finishedCV = false;

    currentEditDiagnosis = null;

    constructor(
        public authService: AuthService,
        public baseService: BaseService,
        public router: Router,
        public appService: AppService,
        public route: ActivatedRoute,
        public patientService: PatientService,
        public proposalDiagnosisService: ProposalDiagnosisService,
        public translate: TranslateService
    ) {
        super(authService, router, baseService, appService);

    }

    ngOnInit() {
        super.ngOnInit();
        this.translate.onLangChange.subscribe(value => {
            this.lang = value.lang;
        });
        this.initDataList();

        if (!this.patientService.enableProposal) {
            // Need timeout to render tabs before select tab default
            setTimeout(() => {
                this.selectTab(this.PROPOSAL_ACTION.manual);
            }, 200);
        }


        this.updateDiagnosisSub = this.appService.subscribe('updateDiagnosis', data => {
            if (data.error) {
                this.showError(data.errorMessage);
            }
            this.initDataList(data.items);
        });

        const wrapper = document.getElementById('proposal-diagnoses');
        this.stickyWidth = (wrapper.offsetWidth - 6) + 'px';

        this.diagnosesSub = this.appService.subscribe('diagnoses', data => {
            if (data['selectedDiagnosesToEdit']) {
                this.currentEditDiagnosis = data.diagnosis;
                if (this.currentEditDiagnosis) {
                    this.selectTab(this.PROPOSAL_ACTION.manual);
                    // Wait ui render then scroll to current selected diagnosis
                    setTimeout(() => {
                        this.perfectScrollbarComp.directiveRef.scrollToElement('#diagnosis-' + this.currentEditDiagnosis['id']);
                    }, 100);
                    return;
                }

                if (this.finishedCV && this.toReviewDiagnosis.length === 0) {
                    this.selectTab(this.PROPOSAL_ACTION.manual);
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.updateDiagnosisSub) {
            this.updateDiagnosisSub.unsubscribe();
        }

        if (this.diagnosesSub) {
            this.diagnosesSub.unsubscribe();
        }
    }

    close() {
        return this.closeProposalDiagnosis.emit();
    }

    openSelection() {
        this.close();
        this.patientService.symptomMapAction.next({ action : this.patientService.ACTION.open_diagnosis });
    }

    highlightDiagnosis(diagnosis) {
        let currentHighlightDiagnosis = this.filteredProposals.find( proposal => { return  proposal['highlight'] === true });
        if (currentHighlightDiagnosis && diagnosis.diagnoses_id !== currentHighlightDiagnosis.diagnoses_id) {
            currentHighlightDiagnosis['highlight'] = false;
            this.callHighlightDiagnosis(currentHighlightDiagnosis);
        }
        diagnosis['highlight'] = !diagnosis['highlight'] ? true : false;
        this.currentHighlightDiagnosis = diagnosis;
        this.callHighlightDiagnosis(diagnosis);
    }

    callHighlightDiagnosis(diagnosis) {
        const criterias = diagnosis.criterias;
        criterias.forEach(criteria => {
            criteria.groups.forEach(group => {
                let groupIds = [];
                if (group.type !== this.GROUPTYPES.SYMPTOM) {
                    return;
                }
                group.sub_groups.forEach(item => {
                    let ids = _.map(item, 'system_id');
                    groupIds = groupIds.concat(ids);
                });

                if (groupIds.length) {
                    let status;
                    for (const [key, value] of Object.entries(this.CRITERIA_STATUSES)) {
                        if (group.default_status === value) {
                            status = key;
                        }
                    }
                    return this.highlight.emit(
                        {
                            'id': groupIds,
                            'class': status + '-highlight',
                            'selected': diagnosis.highlight
                        });
                }
            });
        });
    }

    initDataList(proposalsData = null, updateFilter = true, highlightProposal = null) {
        if (proposalsData) {
            this.diagnosesProposal = proposalsData;
            this.dismissedDiagnosis = [];
            this.acceptedDiagnosis = [];
            this.toReviewDiagnosis = [];
        }
        if (updateFilter) {
            this.resetFilters();
        }

        if (this.diagnosesProposal) {
            this.diagnosesProposal.forEach(proposal => {
                if (highlightProposal && proposal.id === highlightProposal.id) {
                    this.highlight.emit(false);
                    this.highlightDiagnosis(proposal);
                }
                switch (proposal.status) {
                    case 1:
                        if (!this.isExistProposal(this.acceptedDiagnosis, proposal)) {
                            this.acceptedDiagnosis.push(proposal);
                        }
                        break;
                    case 2:
                        if (!this.isExistProposal(this.dismissedDiagnosis, proposal)) {
                            this.dismissedDiagnosis.push(proposal);
                        }
                        break;
                    default:
                        if (!this.isExistProposal(this.toReviewDiagnosis, proposal)) {
                            this.toReviewDiagnosis.push(proposal);
                        }
                        break;
                }
                // If status not map with tab selected => return
                if (proposal.status !== this.tabSelected) {
                    return;
                }

                if (proposal.hasOwnProperty('related_domain')) {
                    proposal.related_domain.forEach(item => {
                        return !_.find(this.extendFilters.domain, { id: item.id }) ? this.extendFilters.domain.push(item) : false;
                    });
                }

                if (!_.includes(this.extendFilters.icdChapter, proposal.icd_chapter)) {
                    this.extendFilters.icdChapter.push(proposal.icd_chapter);
                }
            });
            let _self= this;
            setTimeout( function(){
                _self.countingDiagnosis = {
                    accept: _self.acceptedDiagnosis.length,
                    dismiss: _self.dismissedDiagnosis.length,
                    review: _self.toReviewDiagnosis.length,
                };

                if (_self.finishedCV) {
                    if (_self.toReviewDiagnosis.length === 0) {
                        _self.appService.publish('updateQuestionnaireStatus', { progess_status_code : 8, step_text : 'Diagnosis set' });
                    } else {
                        _self.appService.publish('updateQuestionnaireStatus', { progess_status_code : 7, step_text : 'CV completed' });
                    }
                }
                _self.firstInit = false;
            }, 1000);
            this.extendFilters.domain = _.sortBy(this.extendFilters.domain, 'name_' + this.lang);
            this.extendFilters.icdChapter = this.extendFilters.icdChapter.sort();
            this.filteredProposals = this.getFilteredData();
        }

        if(this.mapData) {
            // Calculate domain on map
            let doneDomain = 0;
            let totalDomain = 0;
            this.mapData.domain.forEach(domain => {
                if (!domain.is_show_on_task_list) {
                    return;
                }
                totalDomain++;
                if (domain.is_marked) {
                    doneDomain++;
                }
            });
            this.finishedCV = doneDomain === totalDomain ? true : false;
        }
    }

    selectTab(tabId: number) {
        if (this.tabs && this.tabs.tabs.length > 0) {
            this.tabs.tabs[tabId].active = true;
            this.tabSelected = tabId;
            this.resetFilters();
            return this.initDataList();
        }
    }

    setActiveCriteria(criteria) {
        this.activeCriteria = criteria;
        // Reset scrollbar
        const _self = this;
        setTimeout(function(){
            _self.updateScrollbar();
        }, 100);
    }

    setActiveDiagnosis(proposal){
        this.activeProposalDiagnosis = proposal;
        if (proposal) {
            //Make sure highlight always true when go to criteria
            proposal['highlight'] = false;
            this.highlightDiagnosis(proposal);
            this.lastAccessedProposalDiagnosis = proposal;

            const _self = this;
            setTimeout(function(){
                _self.updateScrollbar();
            }, 100);
        }
    }

    updateScrollbar() {
        this.perfectScrollbarComp.directiveRef.update();
        this.perfectScrollbarComp.directiveRef.scrollToTop(0);
        const header = document.querySelector('.tasklists--wrapper__header.sticky') as HTMLElement;
        this.stickyHeight = header ? (header.offsetHeight + 6) + 'px' : this.stickyHeight;
    }

    setHighlightSymptom($event, symptom){
        if(this.hoverOnSymptom) {
            return false;
        }
        // Return if hover on child element of the same item
        if (this.targetSymptom && this.targetSymptom.innerText === $event.currentTarget.innerText) {
            return;
        }
        this.targetSymptom = $event.currentTarget || $event.srcElement;
        this.hoverOnSymptom = true;
        const _self = this;
        this.timer = setTimeout(function () {
            _self.highlightSymptom.emit(symptom);
            _self.hoverOnSymptom = false;
        }, 300);
    }

    unhighLightSymptom($event, symptom){
        const elementRelated = $event.toElement || $event.relatedTarget;
        if (this.targetSymptom.contains(elementRelated) || ($event.toElement && this.targetSymptom.innerText === $event.toElement.innerText)) {
            return;
        }
        clearTimeout(this.timer);
        this.hoverOnSymptom = false;
        this.targetSymptom = null;
        this.highlightSymptom.emit(false);
    }

    updateRatingProposalDetail(domain, symptom, feelingIndex, ratingPoint, isAnamnestic = 0){
        const feeling = symptom['feelings'][feelingIndex];
        // Move to Done tab if don't have sub symptoms
        symptom['passed'] = symptom['feelings'].length === 1 ? true : false;
        return this.updateRating(feeling, ratingPoint, symptom, isAnamnestic, symptom.domain_id, domain);
    }

    updateRating(feeling, ratingPoint, symptom, isAnamnestic = 0, domainId = 0, domain = null) {
        const newRating = this.selectionList[ratingPoint]['class'];
        let oldRatingPoint = '';
        Object.entries(this.selectionList).forEach(([key, value]) => {
          if (value['class'] === feeling.rating) {
            oldRatingPoint = key;
          }
        });
        if (feeling.rating === newRating)  {
            return;
        }
        feeling.rating = newRating;
        this.setMapDisable.emit(true);
        const feelingId = feeling.id;
        feeling.rating = this.selectionList[ratingPoint]['class'];
        let primary = feeling.is_primary_on_map;

        // Auto Set Primary for Symptom have multi levels
        if (symptom) {
            const primaryItem = symptom['feelings'].find(function(feelingItem) {
                return feelingItem.is_primary_on_map === 1;
            });
            // If don't have any primary item => set this feeling to primary
            if(!primaryItem) {
                primary = 1;
            }
        }
        feeling.is_primary_on_map = primary;
        const data = {
            patient_questionnaire_id: this.symptomMapId,
            domain_id: domainId && !this.selectedSymptom ? domainId : this.selectedSymptom.domain_id,
            feelings: [feelingId],
            selected_feeling: isAnamnestic ? feeling.anamnestic_feeling_id : feelingId,
            selected: ratingPoint !== 'none' ? 1 : 0,
            anam_feelings: feeling.anamnestic_feeling_id ? [feeling.anamnestic_feeling_id] : [],
            rating: this.selectionList[ratingPoint]['rating'],
            is_primary  : primary,
            lang : this.lang,
            is_diagnosis: 1,
            isAcute: isAnamnestic ? 0 : 1,
        };

        this.proposalDiagnosisService.updateRating(data).subscribe((rs) => {
            if (rs['results'] && rs['success']) {
                const resDomain = rs['results']['domain'];
                const res = {
                    data: resDomain['data'],
                    rating: ratingPoint,
                    item: data,
                    icon: rs['results']['icon'],
                    domainId: resDomain['data']['domain_map_id'],
                    domainCls: resDomain['domain_class'],
                    isAnamnestic: isAnamnestic,
                    activeDomain: null,
                    activeSymptom: this.selectedSymptom
                };
                // If this feeling is Primary => Update on map
                if(this.primaryOnMapItem && feelingId === this.primaryOnMapItem.id){
                    this.selectedFeeling = feeling;
                }

                // If have new data Proposal => get new list
                if (rs['results']['proposal_diagnosis']) {
                    // Update proposal data on service
                    this.patientService.proposalData = rs['results']['proposal_diagnosis'];
                    this.appService.publish('patient', { proposalDiagnosisDataChanged: true});
                    this.initDataList(rs['results']['proposal_diagnosis'], true, this.currentHighlightDiagnosis);
                }

                // If is Activating a Criteria => update status
                // If is Activating a Proposal => update status
                if(this.activeCriteria){
                    const currentProposal = _.find(rs['results']['proposal_diagnosis'], { id: this.activeCriteria.proposal_diagnoses_id});
                    if (currentProposal) {
                        this.activeCriteria = _.find(currentProposal.criterias, { id: this.activeCriteria.id});
                        if(this.activeProposalDiagnosis){
                            this.activeProposalDiagnosis = currentProposal;
                        }
                    } else {
                        this.showConfirmAfterUnselectSymptom(feeling, oldRatingPoint, symptom, isAnamnestic, domainId);
                    }
                }
                /**
                Update domain data on map
                 */
                this.updateInteractiveDomainData(domainId, resDomain['data'], rs['results']['icon']);

                this.setMapDisable.emit(false);
                return this.updateMap.emit(res);
            }
        },
        (error) => {
            symptom['passed'] = false;
            this.setMapDisable.emit(false);
            this.showError(error.error.error);
        });
    }

    updatePrimary(feeling, symptom = null) {
        if ((!this.symptomMapId) && !symptom) {
            return;
        }

        const selectedFeelings = symptom ? symptom['feelings'] : this.selectedFeelings;
        const feelingIds = selectedFeelings.map(function(item){
            return item.id;
        });
        const anamnesticFeelingIds = selectedFeelings.flatMap(function(feelingItem) {
            return feelingItem.anamnestic_feeling_id ? feelingItem.anamnestic_feeling_id : [];
        });

        // Update primary item
        feeling.is_primary_on_map = 1;
        this.selectedFeeling = feeling;
        this.primaryOnMapItem = feeling;
        selectedFeelings.forEach(function(item) {
            item.is_primary_on_map = item.id === feeling.id ? 1 : 0;
        });

        const data = {
            patient_questionnaire_id: this.symptomMapId,
            feelings: feelingIds.concat(anamnesticFeelingIds),
            primary_id: feeling.anamnestic_feeling_id ? [feeling.id].concat(feeling.anamnestic_feeling_id) : [feeling.id],
            domain_id : symptom ? symptom.domain_id : this.selectedSymptom.domain_id,
            lang : this.lang,
        };
        this.proposalDiagnosisService.updatePrimary(data).subscribe((rs) => {
            if (rs['results'] && rs['success']) {
                const resDomain = rs['results']['domain'];
                const res = {
                    data: rs['results']['data'],
                    icon: rs['results']['icon'],
                    system_id: rs['results']['system_id'],
                    domainCls: resDomain['domain_class'],
                    domainId: resDomain['data']['domain_map_id'],
                    feeling: feeling,
                    activeSymptom: this.selectedSymptom,
                    // activeDomain: this.activeDomain,
                };
                return this.updateMap.emit(res);
            }
        },
        (error) => {
            this.showError(error.error.error);
        });
    }

    updateInteractiveDomainData(domainId, updatedDomainData, icon) {
        const index = this.mapData.domain.findIndex(domain => domain.id === domainId);
        const oldDomainData = this.mapData.domain[index];
        const mergedObject = _.merge(oldDomainData, updatedDomainData, (objValue, srcValue) => {
            if (_.isObject(objValue)) {
                return _.merge(objValue, srcValue);
            }
        });

        // Bug 7063 -- Update feeling rating on domain
        // Fix color of feeling not correct when click
        mergedObject.symptoms.forEach(symptom => {
            if (symptom['system_id'] === icon['system_id']) {
                symptom['feelings'][0]['rating'] = icon['rating-class'];
                return;
            }
        });
        this.mapData.domain[index] = mergedObject;
    }

    goBack(updateDomainData = false) {
        this.setActiveSymptom(false);

        if (this.oldActiveCriteria) {
            this.setActiveCriteria(this.oldActiveCriteria);
            this.oldActiveCriteria = null;
        }
        const _self = this;
        setTimeout(function () {
            return _self.selectTab(_self.tabSelected);
        }, 200);
    }

    setActiveSymptom(symptom, domain = {}){
        if (!symptom || !domain) {
            this.selectedSymptom = null;
            this.highlightSymptom.emit(false);
            return false;
        }
        this.selectedSymptom = symptom;
        this.selectedFeelings = symptom['feelings'];
        this.selectedFeeling = symptom['feelings'][0];
        this.primaryOnMapItem = this.selectedFeelings.find(function (feeling) {
            return feeling.is_primary_on_map === 1;
        });
        this.selectedSymptom.have_statement = !symptom.feelings.some((item) => {
            return item['statement_' + this.lang] === '';
        });
    }

    closeDetails(isViewOnly) {
        this.selectedSymptom = null;
        if (!isViewOnly) {
            return this.closeInteractive.emit({
                interactive: true,
                fullscreen: true,
                selectedSymptom: this.selectedSymptom
            });
        }
        return this.closeInteractive.emit(false);
    }

    getFilteredData() {
        if (!this.extendFiltered.domain && !this.extendFiltered.icdChapter && !this.extendFiltered.probability) {
            const filteredData = this.diagnosesProposal.filter(proposal => {
                return proposal.status === this.tabSelected;
            });
            return filteredData;
        }
        const filteredDatas = this.diagnosesProposal.filter(proposal => {
            // Remove out filtered if Proposal not map with Tab selected
            if (proposal.status !== this.tabSelected) {
                return false;
            }
            // Skip filter if Proposal have no criteria
            if (!proposal.hasOwnProperty('criterias')) {
                return true;
            }
            return (!this.extendFiltered.domain || _.find(proposal.related_domain, { id : this.extendFiltered.domain.id }))
                && (!this.extendFiltered.icdChapter || proposal.icd_chapter === this.extendFiltered.icdChapter)
                && (!this.extendFiltered.probability || (proposal.percentage.from > this.extendFiltered.probability))
                // if Proposal have no Criteria => Skip filter
                || !proposal.hasOwnProperty('related_domain');
        });
        return filteredDatas;
    }

    resetFilters() {
        this.extendFiltered = {
            domain: null,
            icdChapter: null,
            probability: <number> null
        };
        this.extendFilters = _.cloneDeep(this.defaultFilters);
    }

    setExtendFilters(type) {
        this.filteredProposals = this.getFilteredData();
    }

    getStatus(status){
        for(const stt in this.CRITERIA_STATUSES) {
            if (this.CRITERIA_STATUSES[stt] === status) {
                return stt;
            }
        }
    }

    updateStatus(item, type){
        const data = {
            patient_questionnaire_id : this.symptomMapId,
            id : item.id,
            status : item.updated_status,
            type : type
        };
        this.waitingAPI = true;
        this.proposalDiagnosisService.updateStatus(data).subscribe((rs) => {
            if (rs['success'] && rs['proposal_diagnosis']) {
                // Update Criteria Status of Active Proposal
                if (this.activeCriteria && this.activeProposalDiagnosis) {
                    this.activeProposalDiagnosis = _.find(rs['proposal_diagnosis'], { id: this.activeProposalDiagnosis.id });
                    this.activeCriteria = _.find(this.activeProposalDiagnosis.criterias, { id: this.activeCriteria.id });
                }
                this.waitingAPI = false;
                return this.initDataList(rs['proposal_diagnosis'], false);
            }
        },
        (error) => {
            this.showError(error.error.error);
            this.waitingAPI = false;
        });
    }

    setActionProposal(proposal, action) {
        let data = {
            patient_questionnaire_id: this.symptomMapId,
            id: proposal.id,
            diagnoses_id: proposal.diagnoses_id,
            status: action
        };

        this.waitingAPI = true;
        this.proposalDiagnosisService.reviewProposal(data).subscribe((rs) => {
            if (rs['success'] && rs['proposal_diagnosis']) {
                this.patientService.selectedDiagnoses = rs['selectedDiagnosis'];
                this.patientService.proposalData = rs['proposal_diagnosis'];
                const publishData = {
                    selectedDiagnosesAreUpdated: true
                };
                if (action === this.PROPOSAL_ACTION.dismiss) {
                    publishData['isDelete'] = 1;
                }
                this.appService.publish('diagnoses', publishData);
                this.appService.publish('patient', {selectedDiagnosesAreUpdated: true});
                // Update Status of active Proposal
                if (this.activeProposalDiagnosis) {
                    let currentProposal = _.find(this.patientService.proposalData, { id: this.activeProposalDiagnosis.id});
                    this.activeProposalDiagnosis.status = currentProposal.status;
                }
                this.waitingAPI = false;
                // Animation for updated Tab
                this.recentUpdatedTab = action;
                return this.initDataList(rs['proposal_diagnosis'], false, this.currentHighlightDiagnosis);
            }
        },
        (error) => {
            this.showError(error.error.error);
            this.waitingAPI = false;
        });
    }

    goToProposal(exclude) {
        let diagnosis = this.diagnosesProposal.filter(item => { return exclude.diagnoses_id === item['diagnoses_id']});
        this.oldActiveCriteria = this.activeCriteria;
        this.setActiveDiagnosis(diagnosis[0]);
        this.setActiveCriteria(false);
    }

    goToSymptom(exclude, popover) {
        let symptom = this.mapData.symptoms.filter(item => {
            return item.id === exclude.id
        });
        this.setActiveSymptom(symptom[0]);
        popover.hide();
    }

    isExistProposal(listProposals, proposal){
        return _.find(listProposals, { diagnoses_id: proposal.diagnoses_id });
    }

    showConfirmAfterUnselectSymptom(feeling, ratingPoint, symptom, isAnamnestic, domainId) {
        const confirmModal = this.dialog.openConfirm({
            content: 'Deselecting the symptom would remove the diagnose proposal. Continue with the selection?',
            icon: 'fas fa-exclamation-triangle'
        });

        confirmModal.onSubmit(() => {
            this.setActiveCriteria(false);
            this.setActiveDiagnosis(false);
            confirmModal.hideModal();
        });

        confirmModal.onCancel(() => {
            this.updateRating(feeling, ratingPoint, symptom, isAnamnestic, domainId);
        });
    }

    backToCVTab() {
        this.patientService.symptomMapAction.next({ action : this.patientService.ACTION.cv_map });
    }

    showError(message) {
        this.showErrorModal.emit({
            params: {
                icon: 'fas fa-exclamation-triangle',
                warning: true
            },
            errorMessage : message
        });
    }
}
